<template>
  <div class="father">
    <div class="" style="margin:5px">
      <div style="width:100%;height:auto;padding:0 10px 0 10px;">
        <div style="" class="card-title">
          <div style="display:inline-block;">
            <el-button type="primary" @click="createVipCard" plain
              >新建会员卡</el-button
            >
            <!-- <el-button type="primary" plain>发放会员卡</el-button> -->
          </div>
          <el-form
            :inline="true"
            class="demo-form-inline"
            style="display:inline-block;"
            @submit.native.prevent
          >
            <el-form-item label="会员卡名称">
              <el-input
                placeholder="会员卡名称"
                v-model="search_input"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="search">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- :cell-style="{ padding: '7px' }" -->
        <!-- 会员卡表格 -->
        <div :style="`width:${tbmax_width}px`">
          <el-table
            border
            :header-cell-style="{
              color: '#606266'
            }"
            max-height="500"
            ref="multipleTable"
            :data="cardData"
            tooltip-effect="dark"
            style="width: 100%;"
          >
            <el-table-column fixed align="center" type="index" width="55">
            </el-table-column>
            <el-table-column
              fixed
              align="center"
              label="卡号"
              prop="classify_no"
              width="150"
            >
            </el-table-column>
            <el-table-column
              fixed
              align="center"
              prop="classify_name"
              label="会员卡名"
              width="240"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="wx_card_id"
              label="绑定微信"
              width="300"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="status"
              label="状态"
              width="120"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="supply_balance"
              label="允许支付"
              width="120"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="supply_bonus"
              label="允许积分"
              width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="会员卡介绍"
              prop="detail"
              width="240"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="使用提示"
              prop="prerogative"
              width="240"
            >
            </el-table-column>

            <!-- <template slot-scope="scope">
              <div slot="reference" style="color:#67C23A;font-weight:700">
                {{ scope.row.count }}
              </div>
            </template> -->

            <el-table-column
              fixed="right"
              width="200"
              align="center"
              label="操作"
            >
              <template slot-scope="scope"
                ><el-button
                  size="mini"
                  type="primary"
                  :disabled="scope.row.wx_card_id !== null"
                  @click="cardleBindWX(scope.$index, scope.row)"
                  >绑定微信</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="changeCardType(scope.$index, scope.row)"
                  >状态</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <createCard
      ref="createCardRef"
      v-show="true"
      :title="'新建会员卡'"
      @closeCreateCard="closeCreateCard"
    >
      
      <template v-slot:cardForm>
        <cardForm ref="cardFormRef"></cardForm>
      </template>
      <template v-slot:btn_name>
        <el-button
          type="primary"
          plain
          style="margin-left:204px"
          @click="createCard"
          >创建会员卡
        </el-button>
      </template>
    </createCard>
    <el-dialog title="修改卡状态" :visible.sync="dialogFormVisible" width="30%">
      <el-form
        :model="modidyCardForm"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="卡号">
          {{ modidyCardForm.card_id }}
        </el-form-item>
        <el-form-item label="卡状态">
          <el-switch
            v-model="modidyCardForm.status"
            active-text="启用"
            inactive-text="禁用"
            active-value="1"
            inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="令牌">
          <el-input v-model="modidyCardForm.access_token"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeType">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetCardClassify,
  GenerateWxCard,
  testRes,
  RefreshCardStatus
} from "@/api/index";
import cardForm from "@/components/cardForm.vue";
import createCard from "@/components/createCard.vue";
export default {
  name: "MyCard",
  components: {
    createCard,
    cardForm
  },
  watch: {
    search_input: {
      handler(new_input, old_input) {
        this.search();
      }
    },
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.tbmax_width = newinner.innerWidth -250;
        } else {
          this.tbmax_width = newinner.innerWidth-250;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  data() {
    return {
      tbmax_width:"",
      search_input: "",
      dialogFormVisible: false,
      modidyCardForm: { card_id: "", status: "1", access_token: "" },
      card_id: "",
      card_name: "",
      coupon_id: "",
      coupon_name: "",
      height: "height:" + (document.body.clientHeight - 450) + "px",
      cardData: [],
      allCard: [],
      couponData: [
        {
          id: "20220912",
          name: "某超市金卡",
          type: "优惠卷",
          detail: `￥2
          满￥50可用
          `,
          emit_count: 99,
          all_count: 10000,
          count: "99 / 10000",
          duration: "永久",
          create_date: "2022-09-12"
        },
        {
          id: "20220912",
          name: "某超市金卡",
          type: "优惠卷",
          detail: `￥2
          满￥50可用
          `,
          emit_count: 99,
          all_count: 10000,
          count: "99 / 10000",
          duration: "永久",
          create_date: "2022-09-12"
        },
        {
          id: "20220912",
          name: "某超市金卡",
          type: "优惠卷",
          detail: `￥2
          满￥50可用
          `,
          emit_count: 99,
          all_count: 10000,
          count: "99 / 10000",
          duration: "永久",
          create_date: "2022-09-12"
        },
        {
          id: "20220912",
          name: "某超市金卡",
          type: "优惠卷",
          detail: `￥2
          满￥50可用
          `,
          emit_count: 99,
          all_count: 10000,
          count: "99 / 10000",
          duration: "永久",
          create_date: "2022-09-12"
        },
        {
          id: "20220912",
          name: "某超市金卡",
          type: "优惠卷",
          detail: `￥2
          满￥50可用
          `,
          emit_count: 99,
          all_count: 10000,
          count: "99 / 10000",
          duration: "永久",
          create_date: "2022-09-12"
        }
      ],
      multipleSelection: []
    };
  },
  async mounted() {
    this.getCard();
  },
  methods: {
    changeCardType(index, row) {
      this.dialogFormVisible = true;
      this.modidyCardForm.card_id = row.classify_no;
      this.modidyCardForm.status = row.status ? row.status : "1";
    },
    createVipCard() {
      this.$refs.createCardRef.openBox();
    },
    createCard() {
      this.$refs.cardFormRef.createCard();
    },
    async cardleBindWX(index, row) {
      /* testRes(
        await GenerateWxCard({
          card_id: row.classify_no
        }),
        "绑定wx成功"
      ); */
      this.getCard();
    },
    async changeType() {
      const access_token = this.modidyCardForm.access_token;
      this.modidyCardForm.access_token = await this.$encrypt(
        this.modidyCardForm.access_token
      );
     /*  testRes(
        await RefreshCardStatus(JSON.stringify(this.modidyCardForm)),
        "状态修改成功"
      ); */
      this.modidyCardForm.access_token = access_token;
      this.getCard();
    },
    search() {
      let card_list = [];
      const arr = this.allCard;
      for (var x = 0; x < arr.length; x++) {
        if (arr[x].classify_name.indexOf(this.search_input) >= 0) {
          card_list.push(arr[x]);
        }
      }
      this.cardData = [];
      this.cardData = card_list;
    },
    closeCreateCard(res) {
      this.getCard();
    },
    async getCard() {
      return;
      var result = await GetCardClassify();
      testRes(result);
      const {
        data: { resp_data: res }
      } = result;
      this.cardData = res;
      this.allCard = res;
    }
  }
};
</script>
<style scoped>
.father {
  width: 100%;
  height: 98%;
  background-color: #fff;
}
.card-title {
  height: 50px;
  display: flex;
  justify-content: space-between;
}
.dialog-footer {
  width: 100%;
  text-align: left;
}
.switch-father {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
}
</style>
